
































































import { Component, Vue } from "vue-property-decorator";
import MenuItem from "./MenuItem.vue";
import InfoMessage from "@/components/ui/InfoMessage.vue";
import { ContractsModule } from "@/store/contracts.module";
import { AuthModule } from "@/store/auth.module";
import { UserPermissions } from "@/config/consts";
import DebtNoticeModal from "@/components/dialogs/DebtNoticeModal.vue";

@Component({
  components: {
    MenuItem,
    InfoMessage,
    DebtNoticeModal,
  },
})
export default class MenuView extends Vue {
  get menuItems() {
    const items = [
      { name: ["contract"], tooltip: "contracts" },
      { name: ["abonent"], tooltip: "abonent" },
      { name: ["accounting-points", "point"], tooltip: "points" }, // multiple names
      { name: ["payments"], tooltip: "calcs" },
      { name: ["report-forms"], tooltip: "reports" },
      {
        name: [
          "actions",
          "sendcounts",
          "reconciliation-act",
          "reconciliation-act-netto",
          "contract-vie",
          "invoice-act",
          "change-plan",
          "change-plan-new",
          "change-plan-edit",
        ],
        tooltip: "actions",
      },
      { name: ["debt-notifications"], tooltip: "notices" },
    ];

    if (AuthModule.hasPermissionTo(UserPermissions.SHOW_INVOICES)) {
      items.push({ name: ["invoices"], tooltip: "invoices" });
    }

    return items;
  }

  get isMobile() {
    const bps = ["sm", "xs"];
    return bps.includes(this.$vuetify.breakpoint.name);
  }

  get showDebtButton() {
    return ContractsModule.contractStatus?.IsDebtNotice;
  }

  get showInfoMessage() {
    const debtStatus = ContractsModule.contractStatus?.status;
    return debtStatus === 1 || debtStatus === 2 || debtStatus === 3;
  }

  get showQuestionareInfo() {
    return ContractsModule.questionsList.length > 0;
  }

  get getStatusText() {
    const contractStatus = ContractsModule.contractStatus;
    if (contractStatus?.status !== null) {
      let text = "";
      const id = ContractsModule.contractInfo.contract_number;
      switch (contractStatus?.status) {
        case 1:
          text = this.$t("contractInfo.status.added", {
            contract_id: id,
          }) as string;
          break;
        case 2:
          text = this.$t("contractInfo.status.in_process", {
            contract_id: id,
            date: contractStatus.ActionDate,
          }) as string;
          break;
        case 3:
          text = this.$t("contractInfo.status.terminated", {
            contract_id: id,
            date: contractStatus.ActionDate,
          }) as string;
          break;
        default:
          return "";
      }
      return (
        text +
        this.$t("contractInfo.status.info", {
          sumPPE: contractStatus.sumPPE,
        })
      );
    }
    return "";
  }

  goTo(name: string) {
    this.$router.push({
      name,
      params: {
        id: this.$route.params.id,
      },
    });
  }
}
